module.exports = __webpack_public_path__ + "static/media/logo-green.b36237a7.svg";